// FUNÇÕES/MÓDULOS SITE
import ScrollSmooth from './modules/Animation/scrollLenis'
import AnimationElements  from './modules/Animation/enterElements'
import Footer from './modules/Layouts/footer'
import Menu from './modules/Layouts/menu'
import AnchorLinks from './modules/Utils/anchor_links'
import ImageEnter from './modules/Animation/imageEnter'
import ImagesHovers from './modules/Animation/imageHovers'
import removeEmptyImg from './modules/Utils/removeEmptyImg'
import bootstrapForms from './modules/Forms/bootstrapForms'
import infinityText from './modules/Animation/infinityText'
import changeLang from './modules/Utils/changeLang'

changeLang();
//aplica display: none em imagens sem src/sem cadastro
removeEmptyImg();
//forms
bootstrapForms();
// Layout
Footer()
Menu();

// Animations
ScrollSmooth()
AnimationElements()
ImageEnter()
ImagesHovers()
infinityText()

// Utils
AnchorLinks()